<div class="bmc-api-key-configuration">
    <div class="bmc-api-key-configuration__container" *ngIf="!isLoadingConfiguration; else loadingTemplate">
        <div class="bmc-api-key-configuration__content">
            <div class="bmc-api-key-configuration__description bz-space--stack-m">
                <p>{{ 'API_KEY_CONFIGURATION.DESCRIPTION' | translate }}</p>
            </div>
            <div class="bmc-api-key-configuration__expiration-warning bz-space--stack-m"
                *ngIf="showDisableApiKeyWarning">
                <bzg-message [showCloseBtn]="false" [status]="'warning'">
                    {{ 'API_KEY_CONFIGURATION.DISABLE_API_KEY_WARNING' | translate }}
                </bzg-message>
            </div>
            <div class="bmc-api-key-configuration__form">
                <div class="bmc-api-key-configuration__configured-row bmc-api-key-configuration__form-field bz-space--stack-m"
                    *ngIf="!apiKeyConfiguration.IsConfigured">
                    <span class="bmc-api-key-configuration__status-badge"
                        [ngClass]="'bmc-api-key-configuration__status-badge--not-configured'">
                        {{ ('API_KEY_CONFIGURATION.NOT_CONFIGURED_STATUS' | translate) }}
                    </span>
                </div>
                <div class="bmc-api-key-configuration__configured-row bmc-api-key-configuration__form-field bz-space--stack-m">
                    <label
                        class="bz-form-label bmc-api-key-configuration__configured-label bmc-api-key-configuration__label-with-info">
                        <span>{{ 'API_KEY_CONFIGURATION.ENABLED' | translate }}</span>
                        <bzg-icon [nameIcon]="'info'" [size]="16" class="bmc-api-key-configuration__info-icon"
                            [bzgTooltip]="'API_KEY_CONFIGURATION.ENABLED_INFO' | translate"
                            bzgTooltipPosition="above"></bzg-icon>
                    </label>
                    <bzg-switch name="isEnabled" [(ngModel)]="apiKeyConfiguration.Enabled"
                        (ngModelChange)="onEnabledChange($event)" [disabled]="false"
                        class="bmc-api-key-configuration__configured-switch">
                    </bzg-switch>
                </div>
                <div class="bmc-api-key-configuration__configured-row bmc-api-key-configuration__form-field bz-space--stack-m" *ngIf="isApiKeyExpired()">
                    <span class="bmc-api-key-configuration__status-badge"
                        [ngClass]="'bmc-api-key-configuration__status-badge--expired'">
                        {{ ('API_KEY_CONFIGURATION.EXPIRED_STATUS' | translate) }}
                    </span>
                </div>
                <bzg-date-picker class="bz-space--stack-m bmc-api-key-configuration__expiration-date-picker bmc-api-key-configuration__form-field"
                    [ngClass]="{'bmc-api-key-configuration__expiration-date-picker--disabled': !apiKeyConfiguration.Enabled}"
                    [(ngModel)]="expirationDateInput" (ngModelChange)="onExpirationDateChange()"
                    [isDisabled]="!apiKeyConfiguration.Enabled" [minDate]="minExpirationDate"
                    [maxDate]="maxExpirationDate">
                    <span class="bmc-api-key-configuration__label-with-info">
                        <span>
                            {{ 'API_KEY_CONFIGURATION.EXPIRATION_DATE' | translate }}
                            <span class="bz-required__icon"
                                [ngClass]="{'bmc-api-key-configuration__required-icon--error': shouldShowExpirationDateWarning()}">*</span>
                        </span>
                        <bzg-icon [nameIcon]="'info'" [size]="16" class="bmc-api-key-configuration__info-icon"
                            [bzgTooltip]="getExpirationDateRangeByFieldMessage()"
                            bzgTooltipPosition="above"></bzg-icon>
                    </span>
                </bzg-date-picker>
                <div class="bmc-api-key-configuration__expiration-warning bz-space--stack-m"
                    *ngIf="shouldShowExpirationDateWarning()">
                    <bzg-message [showCloseBtn]="false" [status]="'warning'">
                        {{ getExpirationDateRangeMessage() }}
                    </bzg-message>
                </div>
                <div class="bz-space--stack-l bmc-api-key-configuration__form-field" *ngIf="isDevelopEnvironment">
                    <label class="bz-form-label bmc-api-key-configuration__label-with-info">
                        <span>
                            {{ 'API_KEY_CONFIGURATION.BLOBS_LIFETIME' | translate }}
                            <span class="bz-required__icon"
                                [ngClass]="{'bmc-api-key-configuration__required-icon--error': shouldShowBlobsLifeTimeWarning()}">*</span>
                        </span>
                        <bzg-icon [nameIcon]="'info'" [size]="16" class="bmc-api-key-configuration__info-icon"
                            [bzgTooltip]="getBlobsLifeTimeRangeByFieldMessage()"
                            bzgTooltipPosition="above"></bzg-icon>
                    </label>
                    <div class="bmc-api-key-configuration__blobs-duration-control" #blobsDurationControl>
                        <div class="bz-input-icon bmc-api-key-configuration__blobs-duration-input"
                            [ngClass]="{'bmc-api-key-configuration__blobs-duration-input--disabled': !apiKeyConfiguration.Enabled}">
                            <input type="text" class="bz-input bmc-api-key-configuration__blobs-duration-display"
                                [value]="getBlobsLifeTimeSelectionLabel()" [disabled]="!apiKeyConfiguration.Enabled"
                                readonly (click)="openBlobsLifeTimePicker($event)">
                            <svg class="bz-icon bz-icon-mr time-picker-icon bmc-api-key-configuration__blobs-duration-toggle"
                                [ngClass]="{'bmc-api-key-configuration__blobs-duration-toggle--disabled': !apiKeyConfiguration.Enabled}"
                                height="32px" width="32px" (click)="toggleBlobsLifeTimePicker($event)">
                                <use href="#icon-timer"></use>
                            </svg>
                        </div>

                        <div class="bmc-api-key-configuration__blobs-duration-popup" *ngIf="isBlobsLifeTimePickerOpen"
                            [ngStyle]="blobsLifeTimePopupStyles" (click)="$event.stopPropagation()">
                            <div class="bmc-api-key-configuration__blobs-duration-selects">
                                <div class="bmc-api-key-configuration__blobs-duration-field">
                                    <label class="bmc-api-key-configuration__blobs-duration-field-label">{{
                                        'API_KEY_CONFIGURATION.DAY_PLURAL' | translate }}</label>
                                    <div class="bmc-api-key-configuration__blobs-duration-dropdown-wrapper"
                                        [ngClass]="{'bmc-api-key-configuration__blobs-duration-dropdown-wrapper--open': isBlobsLifeTimeDaysDropdownOpen}">
                                        <input type="number"
                                            class="bz-input bmc-api-key-configuration__blobs-duration-number-input"
                                            [(ngModel)]="blobLifeTimeDaysInputValue"
                                            [disabled]="!apiKeyConfiguration.Enabled" min="0"
                                            [max]="expirationRangeDays.max" step="1"
                                            (focus)="openBlobsLifeTimeDaysDropdown()"
                                            (click)="openBlobsLifeTimeDaysDropdown()"
                                            (ngModelChange)="onBlobsLifeTimeDaysInputChange($event)">
                                        <div class="bmc-api-key-configuration__blobs-duration-options"
                                            *ngIf="isBlobsLifeTimeDaysDropdownOpen" #blobLifeTimeDaysOptionsContainer>
                                            <button type="button"
                                                class="bmc-api-key-configuration__blobs-duration-option"
                                                *ngFor="let day of getVisibleBlobLifeTimeDaysOptions()"
                                                [attr.data-option-value]="day"
                                                [ngClass]="{'bmc-api-key-configuration__blobs-duration-option--selected': day === selectedBlobLifeTimeDays}"
                                                (click)="selectBlobLifeTimeDays(day)">
                                                {{ day }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="bmc-api-key-configuration__blobs-duration-field">
                                    <label class="bmc-api-key-configuration__blobs-duration-field-label">{{
                                        'API_KEY_CONFIGURATION.HOUR_PLURAL' | translate }}</label>
                                    <div class="bmc-api-key-configuration__blobs-duration-dropdown-wrapper"
                                        [ngClass]="{'bmc-api-key-configuration__blobs-duration-dropdown-wrapper--open': isBlobsLifeTimeHoursDropdownOpen}">
                                        <input type="number"
                                            class="bz-input bmc-api-key-configuration__blobs-duration-number-input"
                                            [(ngModel)]="blobLifeTimeHoursInputValue"
                                            [disabled]="!apiKeyConfiguration.Enabled" min="0" max="23" step="1"
                                            (focus)="openBlobsLifeTimeHoursDropdown()"
                                            (click)="openBlobsLifeTimeHoursDropdown()"
                                            (ngModelChange)="onBlobsLifeTimeHoursInputChange($event)">
                                        <div class="bmc-api-key-configuration__blobs-duration-options"
                                            *ngIf="isBlobsLifeTimeHoursDropdownOpen" #blobLifeTimeHoursOptionsContainer>
                                            <button type="button"
                                                class="bmc-api-key-configuration__blobs-duration-option"
                                                *ngFor="let hour of getVisibleBlobLifeTimeHoursOptions()"
                                                [attr.data-option-value]="hour"
                                                [ngClass]="{'bmc-api-key-configuration__blobs-duration-option--selected': hour === selectedBlobLifeTimeHours}"
                                                (click)="selectBlobLifeTimeHours(hour)">
                                                {{ hour }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bmc-api-key-configuration__expiration-warning bz-space--stack-m"
                    *ngIf="isDevelopEnvironment && shouldShowBlobsLifeTimeWarning()">
                    <bzg-message [showCloseBtn]="false" [status]="'warning'">
                        {{ getBlobsLifeTimeRangeMessage() }}
                    </bzg-message>
                </div>
            </div>
        </div>
    </div>

    <div class="bmc-api-key-configuration__actions" *ngIf="!isLoadingConfiguration">
        <bzg-button-primary [disabled]="!canGenerateApiKey()" (click)="onGenerateApiKeyClick()">
            {{ 'API_KEY_CONFIGURATION.GENERATE_API_KEY' | translate }}
        </bzg-button-primary>
    </div>

    <div class="bmc-api-key-configuration__save-footer" *ngIf="!isLoadingConfiguration && apiKeyConfiguration.IsConfigured">
        <div class="bmc-api-key-configuration__save-footer-actions">
            <bzg-button-primary [disabled]="!canSaveConfiguration()" (click)="saveConfiguration()">
                {{ 'API_KEY_CONFIGURATION.SAVE' | translate }}
            </bzg-button-primary>
        </div>
    </div>

    <div class="bmc-api-key-configuration__loading-overlay" *ngIf="isGeneratingApiKey || isSavingConfiguration">
        <bz-loading [size]="'xl'"></bz-loading>
    </div>
</div>

<ng-template #confirmGenerateApiKeyModal>
    <bzg-modal-header>
        <span class="bz-modal__title bmc-api-key-configuration__modal-title-with-icon">
            <bzg-icon [nameIcon]="'warning'" [size]="20" class="bz-icon-color--warning"></bzg-icon>
            {{ 'API_KEY_CONFIGURATION.CONFIRM_UPDATE_API_KEY_TITLE' | translate }}
        </span>
        <bzg-button-icon icon="icn-close" (click)="closeConfirmGenerateApiKeyModal()"></bzg-button-icon>
    </bzg-modal-header>

    <bzg-modal-content>
        <p class="bmc-api-key-configuration__confirm-message">{{ 'API_KEY_CONFIGURATION.CONFIRM_UPDATE_API_KEY_MESSAGE' | translate }}</p>
    </bzg-modal-content>

    <bzg-modal-footer class="bmc-api-key-configuration__modal-footer">
        <bzg-button-secondary class="bz-space--inline-m" (click)="closeConfirmGenerateApiKeyModal()">
            {{ 'GLOBAL.CANCEL' | translate }}
        </bzg-button-secondary>
        <bzg-button-primary (click)="confirmGenerateApiKey()">
            {{ 'API_KEY_CONFIGURATION.CONFIRM_UPDATE_API_KEY_ACTION' | translate }}
        </bzg-button-primary>
    </bzg-modal-footer>
</ng-template>

<ng-template #generatedApiKeyModal>
    <bzg-modal-header>
        <span class="bz-modal__title">{{ 'API_KEY_CONFIGURATION.GENERATED_API_KEY' | translate }}</span>
        <bzg-button-icon icon="icn-close" (click)="closeGeneratedApiKeyModal()"></bzg-button-icon>
    </bzg-modal-header>

    <bzg-modal-content>
        <div class="bmc-api-key-configuration__result">
            <bzg-message [showCloseBtn]="false" [status]="'warning'">
                {{ 'API_KEY_CONFIGURATION.VISIBLE_ONCE' | translate }}
            </bzg-message>

            <div class="bmc-api-key-configuration__generated-field">
                <div class="bmc-api-key-configuration__copy-input-wrapper">
                    <input name="generatedApiKey" type="text" class="bz-input bmc-api-key-configuration__copy-input"
                        [value]="generatedApiKey" disabled
                        [placeholder]="'API_KEY_CONFIGURATION.GENERATED_API_KEY' | translate">
                    <span class="bz-icon bmc-api-key-configuration__copy-icon" [title]="'GLOBAL.COPY_TEXT' | translate"
                        (click)="copyApiKey()">
                        <img src="assets/icons/16x_copy.svg" alt="copy">
                    </span>
                </div>
            </div>
        </div>
    </bzg-modal-content>

    <bzg-modal-footer class="bmc-api-key-configuration__modal-footer">
        <bzg-button-secondary class="bz-space--inline-m" (click)="closeGeneratedApiKeyModal()">
            {{ 'GLOBAL.CLOSE' | translate }}
        </bzg-button-secondary>
        <bzg-button-primary (click)="copyApiKey()">
            {{ 'API_KEY_CONFIGURATION.COPY_API_KEY' | translate }}
        </bzg-button-primary>
    </bzg-modal-footer>
</ng-template>

<ng-template #loadingTemplate>
    <div class="bz-env-loading">
        <bz-loading [size]="'xl'"></bz-loading>
    </div>
</ng-template>